import { computed, ref } from 'vue';
import http, { imageUrl, fileUrl, uploadUrl } from './http';

export default function () {
    const loading = ref(true);
    const info = ref();
    const rencentList = ref();
    const form = ref({
        pageIndex: 1,
        pageSize: 20,
        sortConditions: [
            {
                "sortField": "id",
                "listSortDirection": 1
            }
        ],
        searchWords : ""
    });
    const list = ref();
    const total = ref(0);
    const pages = computed(() => {
        const totalItems = total.value;
        const size = form.value.pageSize;
        if (!size || size <= 0) return 1;
        return Math.ceil(totalItems / size);
    });

    const onPageChange = (page) => {
        form.value.pageIndex = page;
        readPage();
    };

    const onSearchChanged = (event) => {
        if (event.key === 'Enter') {
            console.log(`Search Changed (Enter Key) = (${JSON.stringify(form.value)})`);
            event.preventDefault();
            readPage();
            return;
        }
        if (event.button === 0) {
            console.log(`Search Changed (Search Button ) = (${JSON.stringify(form.value)})`);
            readPage();
            return;
        }
        
    };

    const onSearchClear = () => {
        form.value.searchWords = "";
        console.log(`Search Clear = (${JSON.stringify(form.value)})`);
        readPage();
    }

    function readPage() {
        loading.value = true;
        http.request("post", "/api/site/readarticlepage", form.value).then(data => {
            list.value = data.Rows;
            total.value = data.Total;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }).finally(() => {
            loading.value = false;
        });
    }

    function read(id) {
        loading.value = true;
        http.request("get", "/api/site/readarticle", { id }).then(res => {
            if (res?.Type == 200) {
                info.value = res?.Data
            }
        }).finally(() => {
            loading.value = false;
        });
    }

    function readRecent(count) {
        loading.value = true;
        http.request("get", "/api/site/readarticlerecent", { count }).then(res => {
            if (res?.Type == 200) {
                rencentList.value = res?.Data
            }
        }).finally(() => {
            loading.value = false;
        });
    }

    const generateStructuredData = (article) => {
        if (!article) return null;
        return {
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "headline": article.Title,
            "description": article.MetaDescription || article.Title,
            "author": {
                "@type": "Person",
                "name": "Contractly"
            },
            "datePublished": article.CreatedTime,
            "dateModified": article.UpdatedTime || article.CreatedTime,
            "image": imageUrl(article.Photo, 1200, 0, '', 'max'),
            "publisher": {
                "@type": "Organization",
                "name": "Contractly",
                "logo": {
                    "@type": "ImageObject",
                    "url": "https://contractly.ca/logo.png"
                }
            }
        }
    }

    return {
        loading,
        form,
        info,
        rencentList,
        list,
        total,
        pages,
        onPageChange,
        onSearchChanged,
        onSearchClear,
        readPage,
        readRecent,
        read,
        generateStructuredData // �����·���
    }
}